import React, { useState, useEffect } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";
import { responsive } from "../../data";
import config from "../../config";
import { useLanguage } from "../../Context";

export default function Video() {
  const [items, setItems] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const { language } = useLanguage();

  useEffect(() => {
    setIsLoading(true);
    setError(null);
    fetch(
      `${config.apiUrl}contentapi.php?option=1&type=7&categoryid=1&subcategory=0&limitCount=10&lang=${language}`
    )
      .then((response) => response.json())
      .then((items) => {
        setItems(items);
        setIsLoading(false);
      })
      .catch((error) => {
        setError(error);
        setIsLoading(false);
      });
  }, [language]);

  // Loader before data is loaded
  if (isLoading) {
    return (
      <div className="max-container-width py-3">
        <div className="bg-body-secondary p-3">
          <Carousel responsive={responsive} rtl>
            {[...Array(5)].map((_, index) => (
              <p key={index} className="placeholder-glow mx-2">
                <span
                  className="placeholder card col-12"
                  style={{ height: "13rem" }}
                />
              </p>
            ))}
          </Carousel>
        </div>
      </div>
    );
  }

  // error if data is not fetched
  if (error) {
    return (
      <div className="max-container-width pt-4 pb-3">
        <p className="alert alert-danger" role="alert" dir="ltr">
          Something went wrong: {error.message}
        </p>
      </div>
    );
  }

  return (
    <>
      <div className="max-container-width py-3 primary-text-blue">
        <div className="d-flex justify-content-between align-items-center mb-2 dash-divider">
          <h3
            className="border-end border-5 pe-2 ps-1 bg-body"
            id="secondary-border-yellow"
          >
            {parseInt(language) === 1 ? "ویدیو ها" : "ویډیوګانې"}
          </h3>
          <Link
            to="/video"
            className="d-flex gap-2 align-items-center primary-text-blue pe-1 bg-body"
          >
            <strong className="m-0 p-0">
              {parseInt(language) === 1 ? "مجموع ویدیو ها" : "ټول ویدیوګانې"}
            </strong>
            <img
              src="/img/arrow.png"
              style={{ width: "1.7em", transform: "rotate(180deg)" }}
              alt=""
            />
          </Link>
        </div>
        <div className="bg-body-secondary p-3">
          <Carousel responsive={responsive} rtl>
            {items.map((video) => (
              <Link
                to={`/${video.CategoryE}/${video.SubCategory}/${video.id}`}
                key={video.id}
                className="card mx-2 border-0 text-bg-dark"
              >
                <img
                  src={video.ImageUrl?.replace(
                    /_large(?=\.(jpg|jpeg|png)$)/,
                    "_thumb"
                  )}
                  className="card-img-top object-fit-cover"
                  alt="..."
                  style={{ height: "13rem" }}
                />
                <div className="card-img-overlay d-flex flex-column align-items-center justify-content-center icon-links">
                  <img src="/img/arrow.png" style={{ width: "4em" }} alt="" />
                </div>
              </Link>
            ))}
          </Carousel>
        </div>
      </div>
    </>
  );
}
